import { createFileRoute } from '@tanstack/react-router';
import { TermsPage } from '@/components/marketing/pages/TermsPage';

export const Route = createFileRoute('/_marketing/legal/terms')({
  component: TermsPage,
});
